import React from "react"
import { UserCheckbox } from "./UserCheckbox"

interface User {
  id: number
  [key: string]: any
}

interface NotificationRowProps {
  user: User
  label: string
  description: string
  emailsName?: string | null
  textsName?: string | null
}

export const NotificationRow: React.FC<NotificationRowProps> = ({
  user,
  label,
  description,
  emailsName = null,
  textsName = null,
}) => {
  return (
    <tr className="border-b">
      <td className="py-4">
        <div>
          <div className="">{label}</div>
          <div className="text-xs text-gray-600">{description}</div>
        </div>
      </td>
      {emailsName && (
        <td className="text-center py-4">
          <UserCheckbox
            userId={user.id}
            name={emailsName}
            value={user[emailsName]}
          />
        </td>
      )}
      {!emailsName && <td className="text-center py-4">-</td>}
      {textsName && (
        <td className="text-center py-4">
          <UserCheckbox
            userId={user.id}
            name={textsName}
            value={user[textsName]}
          />
        </td>
      )}
      {!textsName && <td className="text-center py-4">-</td>}
    </tr>
  )
}
